var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpBadge",
    {
      staticClass: "border",
      attrs: {
        title: _vm._f("gettext")("Billing multiplier"),
        "no-box-shadow": "",
        variant: "light"
      }
    },
    [
      _c("ItpIcon", { staticClass: "mr-2", attrs: { name: "fa-times" } }),
      _vm._v(" "),
      _c("ItpText", { attrs: { text: _vm.value } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }